import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Headroom from 'react-headroom';
import classNames from 'classnames';
import CrisisInformationBar from '../CrisisInformationBar';
import Navigation from '../Navigation';
import NavigationMobile from '../NavigationMobile';
import logoVisitSweden from '../../public/img/logotype-visitsweden.svg';
import s from './Header.module.scss';

const Header = ({ navigation, crisisInformation, headerVariant = 'default', heroTextTheme = 'default' }) => {
    const { t } = useTranslation('common');

    const [isDisabled, setIsDisabled] = useState(false);
    const handleDisable = useCallback(() => setIsDisabled((isDisabled) => !isDisabled), []);

    const hideNavigation = headerVariant === 'hide';
    const showMinimalHeader = headerVariant === 'minimal';
    const classes = classNames(
        s['Root'],
        { [s['Root--Minimal']]: showMinimalHeader },
        { [s['Root--HideNavigation']]: hideNavigation },
        { ['Headroom--Sticky']: isDisabled }, // for global headroom styling on mobile menu
        { ['Headroom--DisableSticky']: showMinimalHeader || hideNavigation } // disable sticky positioning for minimal header
    );

    return (
        <>
            <Headroom
                className={classes}
                disableInlineStyles={true}
                tag="div"
                disable={showMinimalHeader || hideNavigation}
                offset={20}
                pinStart={-20}>
                {hideNavigation ? (
                    <div className={s['Root__Container']}>
                        <div className={s['Root__Logotype']}>
                            <a href="/" aria-label={t('navigation.logo')}>
                                <Image
                                    {...logoVisitSweden}
                                    overrideSrc={logoVisitSweden?.src}
                                    alt="VisitSweden"
                                    priority={true}
                                />
                            </a>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={s['Root__Navigation']}>
                            <Navigation {...navigation} />
                        </div>
                        <div className={s['Root__NavigationMobile']}>
                            <NavigationMobile
                                {...navigation}
                                handleDisable={handleDisable}
                                showMinimalHeader={showMinimalHeader}
                                heroTextTheme={heroTextTheme}
                            />
                        </div>
                        <CrisisInformationBar {...crisisInformation} />
                    </>
                )}
            </Headroom>
        </>
    );
};

Header.propTypes = {
    navigation: PropTypes.object,
    crisisInformation: PropTypes.object,
    headerVariant: PropTypes.string,
    heroTextTheme: PropTypes.string,
};

export default Header;
